import { TRUST_SIGNALS } from "@/lib/trust-signals"

/**
 * TrustSignalGrid — the owner's four trust claims as an even stat grid: the number
 * large and bold, its claim line beneath. 2-up on phones, 4-up from `sm`.
 *
 * FRIDGE-1110 (owner: "Present better"). The footer ran the same four claims together
 * as one centered grey sentence joined by dots, which wrapped into ragged centered
 * lines on a phone — design rule §22.2, no ragged piles. The shape it should have had
 * already existed inside TrustStrip, so this is that grid lifted out rather than a
 * second convention invented beside it (§22.8, fix it everywhere, not once).
 *
 * Semantics are part of the point: <dl> with the number as <dt> and the claim as <dd>.
 * The plain-statement sr-only sentences stay in TrustStrip, which is the surface that
 * explains the figures; the footer must not repeat them on every page.
 *
 * The numbers and their wording come from lib/trust-signals.ts and are not touched
 * here — this card is presentation only.
 */
export function TrustSignalGrid({ className = "" }: { className?: string }) {
  return (
    <dl
      className={`grid grid-cols-2 sm:grid-cols-4 divide-x divide-y sm:divide-y-0 divide-gray-100 m-0 ${className}`}
    >
      {TRUST_SIGNALS.map((s) => (
        <div key={s.key} className="px-4 sm:px-5 py-3">
          <dt className="text-[17px] sm:text-lg font-extrabold tracking-tight text-gray-900 leading-none">
            {s.value}
          </dt>
          <dd className="mt-1.5 text-[12px] leading-snug text-gray-600 m-0">{s.label}</dd>
        </div>
      ))}
    </dl>
  )
}
